import { Logo } from '@redturtle/iovisit-theme/components/layout';
import favicon from '@redturtle/iovisit-theme/static/favicon.ico';

export const IoVisitConfig = {
  siteName: 'IO-Visit',
  logo: Logo,
  logoFooter: Logo,
  showFooterMenu: true,
  topLink: {
    text: '',
    url: '',
  },

  leadimage: {
    sizeSmall: {
      contentTypes: ['Document'], //list of content-types with small leadimage,
    },
    hideFor: ['LRF'], //list of content-types that haven't to display leadimage in header
  },

  contentTypeSiteIcons: {
    Venue: { prefix: 'fas', name: 'map-marker-alt' },
    PointOfInterest: { prefix: 'fas', name: 'map-marker-alt' },
    Event: { prefix: 'far', name: 'calendar-alt' },
    Itinerary: { prefix: 'fas', name: 'map' },
    'News Item': { prefix: 'far', name: 'newspaper' },
  },

  favicon: [
    { rel: 'icon', sizes: 'any', href: favicon },
    // { rel: 'icon', sizes: '16x16', href: favicon16 },
    // { rel: 'icon', sizes: '32x32', href: favicon32 },
    // { rel: 'apple-touch-icon', sizes: '180x180', href: appleTouchIcon },
    // { rel: 'mask-icon', color: '#000', href: safariPinnedTab },
  ],

  // name of the @vocabularies entry used to populate the city filter in the
  // SearchEvents block; each iovisit project has its own cities vocabulary,
  // so child themes override this. Leave null to hide the filter.
  eventsCitiesVocabulary: null,
};
